

export default {
	name: 'auth'
};
